import { IAutoApproveReservationSettings, IGoogleReservationsSettings, IReservationSettings } from '@backend/domain'
import { ApiHideProperty, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsNotEmptyObject, IsOptional, Min } from 'class-validator'

/** Settings for auto approving reservations */
export class AutoApproveReservationSettings implements IAutoApproveReservationSettings {
	@ApiProperty({ type: Boolean })
	@IsNotEmpty()
	enabled: boolean

	/** Max overall no of guests in the restaurant allowed for
	 * reservation to be auto approved
	 * 0 means no limit
	 */
	@ApiProperty({ type: Number, minimum: 0 })
	@IsNotEmpty()
	@Min(0)
	guestLimitOverall: number

	/** Max no of guests allowed for reservation to be auto approved
	 * 0 means no limit
	 */
	@ApiProperty({ type: Number, minimum: 0 })
	@IsNotEmpty()
	@Min(0)
	guestLimitPerReservation: number
}

export class ReservationSettings implements IReservationSettings {
	@ApiProperty({ type: AutoApproveReservationSettings })
	@IsNotEmptyObject()
	autoApproveReservations: AutoApproveReservationSettings

	@ApiHideProperty()
	googleReservations: IGoogleReservationsSettings

	/** Default time of reservations */
	@ApiProperty({ type: Number, minimum: 30 })
	@IsNotEmpty()
	@Min(30)
	defaultReservationTime: number

	/** Reservations that start in this time interval (hours) are dispayed in dashboard */
	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@Min(1)
	dashboardReservationTimeLimit: number

	/** Optional latest reservation start (restaurant-local); no slots are offered after it */
	@ApiPropertyOptional()
	@IsOptional()
	lastReservationTime?: { hours: number; minutes: number } | null
}
